import { userDetailStore, UserDetailType } from "../../../stores/userDetailStore";

export function ResetPassword() {
  let userDetailStoreUnsubscribe: () => void;
  let $forgetPasswordBtn: null | HTMLButtonElement = null;

  async function populate(userDetail: UserDetailType) {
    $forgetPasswordBtn = document.getElementById("forget-password-btn") as HTMLButtonElement;

    if (userDetail) {
      $forgetPasswordBtn?.setAttribute("href", `/forgot-password?email=${userDetail.email}`);
    }
  }

  function init() {
    userDetailStoreUnsubscribe = userDetailStore.subscribe(({ userDetail }) => populate(userDetail)); // populate the loading state if workspaces loading
    const userDetail = userDetailStore.userDetail;
    populate(userDetail);
  }

  function cleanUp() {
    if (userDetailStoreUnsubscribe) {
      userDetailStoreUnsubscribe();
    }
  }

  function render() {
    return /*html*/`
  <div class="grid sm:grid-cols-12 gap-y-1.5 sm:gap-y-0 sm:gap-x-5">
    <div class="sm:col-span-4 xl:col-span-3 2xl:col-span-2">
      <label for="hs-pro-dappnp" class="sm:mt-2.5 inline-block text-sm text-gray-500 dark:text-neutral-500">
        Reset Password
      </label>
    </div>

    <div class="sm:col-span-8 xl:col-span-8">
      <div class="flex items-center gap-x-3">
        <a href="" target="_blank" id="forget-password-btn" data-navigo
          class="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none focus:outline-none focus:ring-2 focus:ring-blue-500">
          Click to Reset
          <span class="shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-external-link size-4"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg>
          </span>
        </a>
      </div>
    </div>
  </div>`;
  }

  return { render, init, cleanUp };
}